<app-header-nav></app-header-nav>

<div class="container mx-auto p-6" style="height: calc(100vh - 140px);">
  <div class="flex items-center mb-4">
    <button mat-icon-button (click)="onBack()"><mat-icon>arrow_back</mat-icon></button>
    <h1 class="text-2xl font-bold ml-2">Live Chat</h1>
    <span class="ml-3 text-sm text-gray-500" *ngIf="myEmail">
      Signed in as {{ myEmail }} <span *ngIf="isStaff">(staff)</span>
    </span>
  </div>

  <div class="flex gap-4 h-full">
    <!-- Sessions List -->
    <mat-card class="w-72 flex-shrink-0 p-0 overflow-y-auto">
      <div class="p-3 border-b flex justify-between items-center">
        <span class="font-semibold">{{ isStaff ? 'Incoming chats' : 'My conversations' }}</span>
        <button mat-icon-button (click)="loadSessions()" title="Refresh">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
      <div *ngIf="isLoading" class="flex justify-center py-8"><mat-spinner diameter="32"></mat-spinner></div>
      <div *ngFor="let session of sessions"
        class="p-3 cursor-pointer hover:bg-gray-50 border-b"
        [class.bg-blue-50]="selectedSession?.id === session.id"
        (click)="selectSession(session)">
        <div class="font-medium text-sm">{{ otherParty(session) }}</div>
        <div class="text-xs text-gray-500 truncate">{{ session.lastMessage || 'No messages yet' }}</div>
        <div class="text-xs text-gray-400">{{ session.dateOfStartSession | date:'short' }}</div>
      </div>
      <p *ngIf="!isLoading && sessions.length === 0" class="text-center text-gray-500 py-6 text-sm">
        {{ isStaff ? 'No incoming chats yet' : 'No conversations yet — scan a bar QR to start one' }}
      </p>
    </mat-card>

    <!-- Chat Area -->
    <mat-card class="flex-1 flex flex-col p-0">
      <div *ngIf="!selectedSession" class="flex-1 flex items-center justify-center text-gray-400">
        <div class="text-center">
          <mat-icon style="font-size:64px">chat_bubble_outline</mat-icon>
          <p class="mt-2">Select a conversation to view messages</p>
        </div>
      </div>

      <ng-container *ngIf="selectedSession">
        <div class="p-3 border-b">
          <div class="font-semibold">{{ otherParty(selectedSession) }}</div>
          <div class="text-xs text-gray-500">Session #{{ selectedSession.id }}</div>
        </div>

        <!-- Messages -->
        <div #messageContainer class="flex-1 overflow-y-auto p-4 space-y-3" style="max-height: calc(100% - 140px);">
          <div *ngFor="let msg of messages"
            class="flex"
            [class.justify-end]="isMine(msg)">
            <div class="max-w-xs px-4 py-2 rounded-2xl text-sm"
              [ngClass]="isMine(msg) ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'">
              {{ msg.chatMessage }}
              <div class="text-xs opacity-70 mt-1">{{ msg.dateOfMessage | date:'shortTime' }}</div>
            </div>
          </div>
          <p *ngIf="messages.length === 0" class="text-center text-gray-400 text-sm">No messages yet — say hello</p>
        </div>

        <!-- Input -->
        <div class="p-3 border-t flex gap-2">
          <mat-form-field class="flex-1" appearance="outline">
            <input matInput [(ngModel)]="newMessage" placeholder="Type a message..."
              (keyup.enter)="sendMessage()">
          </mat-form-field>
          <button mat-icon-button color="primary" (click)="sendMessage()" [disabled]="!newMessage.trim()">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </ng-container>
    </mat-card>
  </div>
</div>

<app-footer></app-footer>
